module.exports = __webpack_public_path__ + "img/icon-md-mood-05.ef661b97.svg";